module.exports = __webpack_public_path__ + "img/last_slide.bdf33eeb.jpg";